module.exports = __webpack_public_path__ + "static/media/maruti-logo-login.24bca258.png";